/**
 * Portal V2-only achievement artwork URLs.
 * V1 ImageIcon / Assets/achievements remain unchanged.
 */
import designMyLifeBlueprint from '../../../Assets/achievements-v2/design-my-life-blueprint.png';
import breakthrough from '../../../Assets/achievements-v2/breakthrough.png';
import path from '../../../Assets/achievements-v2/path.png';
import goal from '../../../Assets/achievements-v2/goal.png';
import mystery from '../../../Assets/achievements-v2/mystery.png';
import level1 from '../../../Assets/achievements-v2/level-1.png';
import level2 from '../../../Assets/achievements-v2/level-2.png';
import level3 from '../../../Assets/achievements-v2/level-3.png';
import special77 from '../../../Assets/achievements-v2/milestone-77.png';
import streak77 from '../../../Assets/achievements-v2/streak-77.png';
import special777 from '../../../Assets/achievements-v2/milestone-777.png';
import streak365 from '../../../Assets/achievements-v2/streak-365.png';
import milestoneTier1 from '../../../Assets/achievements-v2/milestone-tier-1.png';
import milestoneTier2 from '../../../Assets/achievements-v2/milestone-tier-2.png';
import milestoneTier3 from '../../../Assets/achievements-v2/milestone-tier-3.png';
import milestoneTier4 from '../../../Assets/achievements-v2/milestone-tier-4.png';
import streakTier1 from '../../../Assets/achievements-v2/streak-tier-1.png';
import streakTier2 from '../../../Assets/achievements-v2/streak-tier-2.png';
import streakTier3 from '../../../Assets/achievements-v2/streak-tier-3.png';
import streakTier4 from '../../../Assets/achievements-v2/streak-tier-4.png';

const BY_MOTIF = {
    blueprint: designMyLifeBlueprint,
    breakthrough,
    path,
    goal,
    mystery,
    level1,
    level2,
    level3,
    special77,
    streak77,
    special777,
    streak365,
};

const FAMILY_TIERS = {
    milestone: [milestoneTier1, milestoneTier2, milestoneTier3, milestoneTier4],
    streak: [streakTier1, streakTier2, streakTier3, streakTier4],
};

function assetUrl(asset) {
    if (!asset) return null;
    if (typeof asset === 'string') return asset;
    if (asset && typeof asset === 'object' && typeof asset.default === 'string') {
        return asset.default;
    }
    return null;
}

export function v2AchievementAssetUrl(motif) {
    return assetUrl(BY_MOTIF[motif]);
}

/** Shared medallion for numeric milestone/streak series (value is overlaid in UI). */
export function v2AchievementFamilyAssetUrl(family, tier = 0) {
    const list = FAMILY_TIERS[family];
    if (!list) return null;
    const index =
        tier <= 1 ? 0 : tier === 2 ? 1 : tier === 3 ? 2 : 3;
    return assetUrl(list[index]);
}
